import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=1ce588ca&"
import script from "./questiondetail.js?vue&type=script&lang=js&"
export * from "./questiondetail.js?vue&type=script&lang=js&"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports